'use strict';
/* tslint:disable:max-line-length */

namespace TR {
    class AmendBooking {

        hiddenQueryString: string;
        destinationName: string;

        constructor(
            booking,
            occupancyService
        ) {
            let stay: any = _.get(booking, 'Itinerary.Stays[0]');
            let occupancy: string = occupancyService.serialise(stay.Rooms);
            this.hiddenQueryString =
                `dest=1-${stay.Hotel.EstabId}&startDate=${stay.CheckIn}&endDate=${stay.CheckOut}&occ=${occupancy}&currency=${booking.Balance.ClientCurrencyCode}`;
            this.destinationName = _.get(stay, 'Hotel.Destinations[0].Title');
        }
    }

    angular
        .module('TR')
        .controller('AmendBooking', AmendBooking);
}
